const updateCustomElementResolvers = {};
const updateCustomElementObservers = {};
// eslint-disable-next-line prefer-destructuring
const HMR_ENABLED = process.env.HMR_ENABLED;

export function addUpdateCustomElementObserver(tagName, observer) {
	if (HMR_ENABLED) {
		const observers = (updateCustomElementObservers[tagName] =
			updateCustomElementObservers[tagName] || new Set());
		observers.add(observer);
		return () => observers.delete(observer);
	}
}

export function setUpdateConfigResolver(tagName, resolver) {
	if (HMR_ENABLED) {
		updateCustomElementResolvers[tagName] = resolver;
	}
}

let unstableUpdateCustomElement;
if (HMR_ENABLED) {
	unstableUpdateCustomElement = (tagName, config = {}, meta = {}) => {
		if (!updateCustomElementResolvers[tagName]) {
			return {
				accept: false,
				reason: `unknown tag "${tagName}"`
			};
		}
		const {supportedConfigKeys, modifiedConfig} = updateCustomElementResolvers[tagName](
			config,
			meta
		);
		const modifiedConfigKeys = Object.keys(modifiedConfig);
		if (modifiedConfigKeys.length === 0) {
			return {
				accept: true,
				reason: 'nothing updated'
			};
		}
		const unsupportedConfigKeys = modifiedConfigKeys.filter(
			key => !supportedConfigKeys.includes(key)
		);
		if (unsupportedConfigKeys.length > 0) {
			return {
				accept: false,
				reason: `unsupported config: [${unsupportedConfigKeys.join(', ')}]`
			};
		}
		for (const observer of updateCustomElementObservers[tagName]) {
			observer(modifiedConfig);
		}
		return {
			accept: true,
			reason: `updated config: [${modifiedConfigKeys.join(', ')}]`
		};
	};
}

let unstableRemoveUpdateForTag;
if (process.env.NODE_ENV === 'test') {
	unstableRemoveUpdateForTag = tagName => {
		delete updateCustomElementResolvers[tagName];
		delete updateCustomElementObservers[tagName];
	};
}

export {unstableUpdateCustomElement, unstableRemoveUpdateForTag};
